<template>
  <div class="myAIGkWeapon page">
    <v-header :headTitle="headTitle" :isBack="false" v-if="false"></v-header>
    <div class="container">
      <div class="container_head">
        <div class="df-between">
          <img
            src="../../assets/images/home/gk_logo.png"
            class="image"
          />
          <div @click="jumpTo('/catalogue')">
            <img
              id="catalogue"
              src="../../assets/images/home/i-catalogue.png"
              class="catalogue"
              v-if="true"
            />
          </div>
        </div>
        <div class="link_title">
          <p class="link_style first" >在医院里，</p>
          <p class="link_style first first_title">感控工作的“繁”与“杂”</p>
          <p class="link_style two">{{ content1 }}</p>
          <p class="link_style three">{{ content2 }}</p>
        </div>
      </div>
      <div class="img-box">
        <img @click="previewImgList(0)" src="../../assets/images/detail/myAIGkWeapon/ai-weapon1.png" alt="" />
        <img @click="previewImgList(1)" src="../../assets/images/detail/myAIGkWeapon/ai-weapon2.png" alt="" />
        <img @click="previewImgList(2)" src="../../assets/images/detail/myAIGkWeapon/ai-weapon3.png" alt="" />
        <img @click="previewImgList(3)" src="../../assets/images/detail/myAIGkWeapon/ai-weapon4.png" alt="" />
        <img @click="previewImgList(4)" src="../../assets/images/detail/myAIGkWeapon/ai-weapon5.png" alt="" />
        <img @click="previewImgList(5)" src="../../assets/images/detail/myAIGkWeapon/ai-weapon6.png" alt="" />
      </div>
      <div
        class="time"
        v-for="(item, index) in timeList"
        :key="item.id + '-time'"
      >
        <div class="df-center w-100">
          <!-- <img class="list_img" :src="item.imgUrl" /> -->
          <span class="time_title">{{ item.title }}</span>
        </div>
        <p v-if="item.content" v-html="item.content"></p>
      </div>
      <div class="hope">
        <div class="foot-category">
          <div class="foot-category-inner">
            <h3 class="about_title about_title_1">联系我们</h3>
            <ul>
              <li
                class="about_desc"
                v-for="(item, index) in contactList"
                :key="item.id + '-contact'"
              >
                <span class="contact about_desc">{{ item.contact }}</span>
                <span class="moblie about_desc" @click="callPhone(item.phone)">{{
                  item.phone
                }}</span>
              </li>
            </ul>
            <div style="height: 40px; width: 100%"></div>
            <template v-if="true">
              <h3 style="margin: 0" class="about_title">关于我们</h3>
              <div class="my_seft">
                <span class="contact about_desc" @click="jumpTo('/detail/myStory')">我们的故事</span>
                <span class="contact about_desc" @click="jumpTo('/serviceList')"
                  >服务清单及报价</span
                >
              </div>
            </template>
          </div>
        </div>

        <img
          v-if="false"
          class="bottom"
          src="../../assets/images/detail/story/bottom_bg.png"
        />
      </div>
    </div>
    <!--    <a href="#banner" v-if="false">-->
    <div class="v-top df-center df-column" @click="goUp" v-show="isBackTopShow">
      <img src="../../assets/images/home/i-top.png" alt="" />
      顶部
    </div>
  </div>
</template>

<script>
import header from "../../components/header/header";
import footer from "../../components/footer/footer";
import BetterScroll from "better-scroll";
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import { Button, Tab, Tabs, Swipe, SwipeItem, ImagePreview, Popup } from "vant";
import axios from "axios";
Vue.use(Button);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup);
export default {
  name: "myStory",
  data() {
    return {
      headTitle: "AI驱动感控升级",
      // 导航栏显示
      isNavShow: true,
      // 返回顶部显示
      isBackTopShow: false,
      content1: "只有我们自己最懂",
      content2:
        "督查整改、试卷排版、表单整理、报告撰写…\n这些高频、重复又耗神的事务，常常把我们\n困在里头\n挤占了真正用于临床指导和风险防控的时间\n今天，我们不谈宏大叙事，只聊真实体验\n感控工作间的AI赋能功能\n到底是噱头，还是真能落地减负\n希望能用老师们的实测说话",
      swipeData: [
        {
          img: require("../../assets/images/detail/myAIGkWeapon/ai-weapon1.png"),
        },
        {
          img: require("../../assets/images/detail/myAIGkWeapon/ai-weapon2.png"),
        },
        {
          img: require("../../assets/images/detail/myAIGkWeapon/ai-weapon3.png"),
        },
        {
          img: require("../../assets/images/detail/myAIGkWeapon/ai-weapon4.png"),
        },
        {
          img: require("../../assets/images/detail/myAIGkWeapon/ai-weapon5.png"),
        },
        {
          img: require("../../assets/images/detail/myAIGkWeapon/ai-weapon6.png"),
        }
      ],
      contactList: [
        { id: 1, contact: "招商合作：", phone: "177-8890-2585" },
        { id: 2, contact: "体验/购买：", phone: "173-5285-9232" },
        { id: 3, contact: "购买后使用：", phone: "189-7584-0173" },
      ],
      timeList: [
        {
          id: 1,
          title: "真正懂感控的工具",
        },
        {
          id: 2,
          title: "从来不是喊着 “数字化” 的口号",
          content:
            "而是从每一个细节出发</br>把我们从繁琐的事务性工作里解放出来</br>让我们能把更多精力投入到真正关乎患者安全的感控核心工作中",
        },
        {
          id: 3,
          title: "感控工作间的这六大AI功能",
          content:
            "不是为了替代我们，而是为了成为我们的 “得力助手”",
        },
        {
          id: 4,
          title: "从督查整改到培训考试",
        },
        {
          id: 5,
          title: "从表单整理到报告撰写",
          content:
            "每一个功能都精准戳中感控人的痛点，实实在在地减轻负担</br>如果你也被这些繁琐事务困扰，不妨试试用AI给工作 “减负”</br>毕竟，我们的价值，不该被这些重复劳动消耗",
        },
      ],
    };
  },
  components: {
    "v-header": header,
    "v-footer": footer,
  },
  mounted() {
    this.cnzzStat('公司介绍', '打开我们的故事','我们的故事(Key_Company_Indroduction)');
    this.isHideNavBar();
    // 窗口滚动事件
    window.addEventListener("scroll", this.handleScroll);
    this.goDefaultTop();
    setTimeout(() => {
        this.initIndexShare()
      }, 500);
  },
  created() {
    setTimeout(() => {
        this.initIndexShare()
      }, 500);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 打电话
    callPhone(phone = "") {
      this.utils.handleOnTell(phone)
    },
    // 预览轮播图
    previewImgList(index) {
      console.log(index);
      let previewImgList = this.swipeData.map((v) => v.img);
      ImagePreview({
        images: previewImgList,
        startPosition: index,
        closeable: true, // pc端图片预览时无法关闭问题
        closeIconPosition: 'top-right'
      });
      console.log(previewImgList, "图片数据");
    },
    // 是否隐藏导航栏
    isHideNavBar() {
      let ua = navigator.userAgent.toLowerCase();
      let isWX = ua.match(/MicroMessenger/i) == "micromessenger";
      console.log(isWX);
      this.isNavShow = !isWX;
    },
    jumpTo(path) {
      // console.log('1111');
      this.$router.push(path);
    },
    // 返回顶部
    goUp() {
      // console.log('返回顶部....')
      let nowTop =
        document.body.scrollTop || document.documentElement.scrollTop; // 获取当前滚动条位置
      // console.log(nowTop);
      if (nowTop > 0) {
        window.requestAnimationFrame(this.goUp);
        window.scrollTo(0, nowTop - nowTop / 5);
      }
    },
  },
};
</script>
  <style lang='scss' scoped>
.myAIGkWeapon {
  .container {
    height: 100%;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
    .container_head {
      box-sizing: border-box;
      height: 488px + 103px;
      background-image: url('../../assets/images/bg-banner222.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      /*-moz-background-size:100% 100%;*/
      :first-child {
        box-sizing: border-box;
        // padding: 5px 0 0 0 ;
        .image {
          // float: left;
          flex-shrink: 0;
          width: 113px;
          height: 43px;
        }
        .catalogue {
          margin-right: 14px;
          flex-shrink: 0;
          width: 24px;
          height: 24px;
          img {
            flex-shrink: 0;
            width: 24px;
            height: 24px;
          }
        }
      }
      .link_title {
        clear: both;
        padding-top: 14px;
        text-align: center;
        .link_style {
          white-space: pre;
          color: #fff;
        }
        .first {
          font-size: 25px;
          font-weight: bold;
          font-family: SourceHanSansCN, SourceHanSansCN-Heavy;
          line-height: 35px;
        }
        .first_title {
          margin-bottom: 10px;
        }
        .two {
          font-size: 17px;
          font-weight: 600;
          font-family: PingFangSC, PingFangSC-Medium;
          line-height: 24px;
        }
        .three {
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Regular;
          margin-top: 5px;
          line-height: 27px;
        }
      }
    }
    .img-box{
      max-width: 500px;
      margin: 0 auto;
      margin-top: -120px;
      margin-bottom: 25px;
      padding: 0px 12px;
      img{
        margin-bottom: 10px;
        width: 100%;
        height: 161px;
      }
    }
    .hope {
      // background-image: url(../../assets/images/detail/story/hope_bg.png);
      // background-repeat: no-repeat;
      // background-size: 100% 100%;
      h3 {
        font-size: 13px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 600;
        text-align: center;
        margin: 70px 20px 0px 20px;
        color: #333333;
        line-height: 18px;
      }
      ul {
        list-style: none;
        padding: 0px;
        margin: 0px;
        text-align: center;
      }
      li {
        margin: 15px 20px 0px 20px;
      }
      .my_seft {
        display: flex;
        padding: 20px 20px 15px 20px;
        text-align: center;
        span {
          flex: 1;
          text-align: center;
        }
      }
      .bottom {
        width: 100%;
        height: 225px;
      }
      .product {
        padding-bottom: 31px;
        text-align: center;
        margin-left: 20px;
      }
      .contact {
        font-size: 13px;
        font-weight: 400;
        text-align: left;
        color: #666666;
        line-height: 18px;
        margin-top: 15px;
      }
      .moblie {
        font-size: 13px;
        font-weight: 400;
        text-align: left;
        color: #1c91ff;
        margin-top: 15px;
        margin-left: 15px;
        line-height: 18px;
      }
    }
    .time {
      text-align: center;
      margin: 15px 20px 0px 20px;
    }
    .time p {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: #333333;
      line-height: 30px;
      margin-top: 10px;
    }
    .time_title {
      font-size: 17px;
      font-family: PingFangSC, PingFangSC-Semibold;
      font-weight: 600;
      text-align: center;
      color: #333333;
    }
  }
  .w-100 {
    width: 100% !important;
  }
  .foot-category {
    position: relative;
    margin-top: -154px;
    height: 488px;
    background: url("../../assets/images/detail/myAIGkWeapon/ai-banner1.png");
    background-size: 100% 100%;
    .foot-category-inner {
      width: 100%;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
    }
  }
  .about_title {
    font-size: 18px !important;
  }
  .about_desc {
    font-size: 16px !important;
  }
  .about_title_1 {
    margin-bottom: 20px  !important;
  }
}
</style>
